import { Term } from '@/types/models'
import { Location } from '../../types/models/Location.model'
import { isGlobal } from '../term'
import { isNonEmptyObject } from '@/utils/checks'
import { isLocationInUnitedStates } from '../location/useCases/isLocationInUnitedStates'

interface PageIsForUnitedStates {
  (props: { term?: Term; location?: Location }): boolean
}

const pageIsForUnitedStates: PageIsForUnitedStates = ({ term, location }) => {
  if (isNonEmptyObject(location)) {
    return isLocationInUnitedStates(location)
  }

  if (isNonEmptyObject(term)) {
    return !isGlobal(term)
  }

  return true
}

export default pageIsForUnitedStates
